import { useEffect, useState } from "react";
import { PageHero, usePageMeta } from "@/components/blocks";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Admin() {
  usePageMeta("Admin — Leads | StrengthLeap", "Internal lead view.");
  const [leads, setLeads] = useState(null);
  const [messages, setMessages] = useState(null);

  useEffect(() => {
    fetch(`${API}/leads`).then((r) => r.json()).then(setLeads).catch(() => setLeads([]));
    fetch(`${API}/contact`).then((r) => r.json()).then(setMessages).catch(() => setMessages([]));
  }, []);

  return (
    <main className="bg-ink text-bone">
      <PageHero testid="admin-page" eyebrow="Internal" lines={["Lead inbox."]} copy="Assessment and contact submissions. Internal use only." />
      <section className="px-6 pb-28 sm:px-10 lg:px-16">
        <div className="mx-auto max-w-[1440px]">
          <h2 className="font-display text-2xl font-black uppercase tracking-tight">
            Assessments {leads ? <span className="text-lime">({leads.length})</span> : "…"}
          </h2>
          <div data-testid="admin-leads-table" className="mt-8 overflow-x-auto border border-bone/15">
            <table className="w-full min-w-[900px] text-left text-sm">
              <thead>
                <tr className="border-b border-bone/15 font-mono text-[10px] uppercase tracking-[0.2em] text-ash">
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Email</th>
                  <th className="px-4 py-3">Country</th>
                  <th className="px-4 py-3">Goal</th>
                  <th className="px-4 py-3">Coaching</th>
                  <th className="px-4 py-3">Budget</th>
                </tr>
              </thead>
              <tbody>
                {(leads || []).map((l) => (
                  <tr key={l.id} className="border-b border-bone/10 text-bone/80">
                    <td className="px-4 py-3 font-mono text-xs">{new Date(l.created_at).toLocaleDateString()}</td>
                    <td className="px-4 py-3">{l.name}</td>
                    <td className="px-4 py-3">{l.email}</td>
                    <td className="px-4 py-3">{l.country || "—"}</td>
                    <td className="px-4 py-3">{l.primary_goal || "—"}</td>
                    <td className="px-4 py-3">{l.coaching_preference || "—"}</td>
                    <td className="px-4 py-3">{l.budget || "—"}</td>
                  </tr>
                ))}
                {leads && leads.length === 0 && (
                  <tr>
                    <td colSpan={7} className="px-4 py-10 text-center font-mono text-xs uppercase tracking-[0.2em] text-ash">
                      No leads yet
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <h2 className="mt-16 font-display text-2xl font-black uppercase tracking-tight">
            Contact messages {messages ? <span className="text-lime">({messages.length})</span> : "…"}
          </h2>
          <div data-testid="admin-messages-table" className="mt-8 space-y-3">
            {(messages || []).map((m) => (
              <div key={m.id} className="border border-bone/15 p-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-ash">
                  {m.topic} — {new Date(m.created_at).toLocaleDateString()}
                </p>
                <p className="mt-2 text-sm text-bone">
                  {m.name} <span className="text-ash">({m.email})</span>
                </p>
                <p className="mt-2 text-sm leading-relaxed text-ash">{m.message}</p>
              </div>
            ))}
            {messages && messages.length === 0 && (
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-ash">No messages yet</p>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}
